module.exports = __webpack_public_path__ + "static/img/2_1_10.37cc31db.jpg";